"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, findIn, findAllIn, removeClass, addClass} from "@elements/dom-utils";

export function init () {
    onFind('.js-variable-date', function (toggleArea) {
        let hiddenDiv = findIn('.js-variable-date__toggle', toggleArea);

        on('click', function () {
            if (findIn('.js-variable-date__checkbox input:checked', toggleArea)) {
                removeClass('d-none', hiddenDiv);
            } else {
                addClass('d-none', hiddenDiv);
            }
        }, toggleArea);
    });

    onFind('.js-room-select', function (roomSelect) {
        let select = findIn('.js-room-select__select', roomSelect);

        on('change', function(select) {
            let val = select.target.value;

            function resetDivs() {
                let childDivs = findAllIn('.js-room-select__toggle', roomSelect);
                let childrenAgeDivs = findAllIn('.js-child-select__toggle', roomSelect);
                let childrenCountDivs = findAllIn('.js-child-select__select', roomSelect);

                let j = 0;
                do {
                    childDivs[j].classList.add("d-none");
                    findIn(".form-select", childDivs[j]).selectedIndex = 0;
                    j++;
                } while (j < childDivs.length)

                j = 0;
                do {
                    childrenAgeDivs[j].classList.add("d-none");
                    findIn(".form-select", childrenAgeDivs[j]).selectedIndex = 0;
                    j++;
                } while (j < childrenAgeDivs.length)

                j = 0;
                do {
                    childrenCountDivs[j].selectedIndex = 0;
                    j++;
                } while (j < childrenCountDivs.length)
            }

            resetDivs();

            if(val != 0) {
                let i = 1;
                while(i <= val) {
                    let hiddenDiv = findIn('.js-room-select__toggle.room-toggle' + i, roomSelect);
                    if (hasClass('d-none', hiddenDiv)) {
                        hiddenDiv.classList.remove("d-none");
                    }
                    i++;
                }
            }
        }, select);
    });

    onFind('.js-room-select__toggle', function (childSelect) {
        let select = findIn('.js-child-select__select', childSelect);

        on('change', function(select) {
            let val = select.target.value;

            function resetDivs() {
                let childDivs = findAllIn('.js-child-select__toggle', childSelect);

                let j = 0;
                do {
                    childDivs[j].classList.add("d-none");
                    findIn(".form-select", childDivs[j]).selectedIndex = 0;
                    j++;
                } while (j < childDivs.length)
            }

            resetDivs();

            if(val != 0) {
                let i = 1;
                while(i <= val) {
                    let hiddenDiv = findIn('.js-child-select__toggle.child-toggle' + i, childSelect);
                    if (hasClass('d-none', hiddenDiv)) {
                        hiddenDiv.classList.remove("d-none");
                    }
                    i++;
                }
            }
        }, select);
    });
};